// extracted by mini-css-extract-plugin
module.exports = {"notifications":"Profile_notifications__1U1nI"};